<script>
import {formatMoney} from "../../../../../components/admin/filters";

export default {
  name: "ConsolidatedCommissionTableButton",
  props: {
    structuredLenderId: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    showDialog: false,
    consolidatedCommissions: []
  }),
  computed: {
    vpnCommissionTotal() {
      return this.consolidatedCommissions.reduce((acc, commission) => acc + commission.vpn_applicant_commission, 0);
    }
  },
  methods: {
    formatMoney,
    async showDialogHandler() {
      this.showDialog = !this.showDialog;
      await this.fetchConsolidatedCommissions();
    },
    async fetchConsolidatedCommissions() {
      this.$vs.loading();
      try {
        const {data} = await axios.get(`/api/backoffice/treasury/trust-management/structured-lender/${this.structuredLenderId}/consolidated-commissions`);
        this.consolidatedCommissions = data;
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: "Ocurrió un error al cargar las comisiones consolidadas",
          color: "danger"
        });
      }
    }
  }
}
</script>

<template>
  <div>
    <vs-button
        @click="showDialogHandler"
        size="small"
        color="black"
        class="uppercase">
      VNP Comisiones consolidada
    </vs-button>

    <vs-popup fullscreen title="Tabla de comisiones consolidada" :active.sync="showDialog">
      <div class="p-4 mx-auto w-64">
        <span class="font-bold">VPN Comisiones:</span>
        {{formatMoney(vpnCommissionTotal)}}
      </div>

      <vs-table stripe :data="consolidatedCommissions">
        <template v-slot:thead>
          <vs-th>#</vs-th>
          <vs-th>Periodo</vs-th>
          <vs-th>Comisión de solicitantes</vs-th>
          <vs-th>VPN Solicitantes</vs-th>
        </template>
        <template scope="{data}">
          <vs-tr v-for="commission in data">
            <vs-td>{{ commission.index }}</vs-td>
            <vs-td>{{ commission.period }}</vs-td>
            <vs-td>{{ formatMoney(commission.consolidated_commission) }}</vs-td>
            <vs-td>{{ formatMoney(commission.vpn_applicant_commission) }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>
